





















































































































































































































































































































































































































































































































































































































import {
  studentStageApi,
  studentStageStatisticsApi,
  statisticsStudentStageListApi,
  statisticsStudentStageListInter,
  statisticsStudentStageListExportInter,
  statisticsStudentStageListExportApi,
} from "@/api/statistics";
import { staffList } from "@/api/globalSearch";
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";
import { Vue, Component, Mixins } from "vue-property-decorator";
import { getFollowLatentApi } from "@/api/studentFollow";
import { dateFormat } from "@/utils/timeFormat";
import { mixin } from "@/mixin/tabPageInfoMixin";
import { exportLoop } from "@/utils/export";
import commonCourseSelector from "@/components/commonCourseSelector.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  components: {
    commonDateRangeSelector,
  },
})
export default class extends Mixins(mixin) {
  searchInfo: any = {
    current_stage: -1,
    acquisition_time: [],
    transform_time: [],
    completion_time: [],
    create_time: [],
    first_visited_time: [],
    first_experienced_time: [],
    sort_type: "desc",
    sort_field: "create_time",
  };
  showFormSearch = false;
  currentStageList: any = [];
  eduTeacherList: any = [];
  courseAdviserList: any = [];
  studentAppearList: any = [];
  studentSourceList: any = [];
  followLatentObj: any = {};
  tableData: any = [];
  stageNum: number = 0; // 学员阶段统计数量;
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  searchFormData: any = {};
  created() {
    this.mixinGetPageInfo("resourceManagement");
    this.handleGetEduTeacherList("");
    this.handleGetCourseAdviserList("");
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.studentAppearList = res.data.list;
      }
    });
    getFollowLatentApi().then((res: any) => {
      const obj: any = {};
      res.data.list.map((item: any) => {
        obj[item.key] = item.value;
      });
      this.followLatentObj = obj;
    });
    if (this.$route.query.start_time && this.$route.query.end_time) {
      this.searchInfo.create_time.push(
        dateFormat("YYYY-mm-dd", Number(this.$route.query.start_time)),
        dateFormat("YYYY-mm-dd", Number(this.$route.query.end_time))
      );
    }
    if (this.$route.query.follow_staff_id) {
      this.searchInfo.follow_staff_id = Number(
        this.$route.query.follow_staff_id
      );
    }
    if (this.$route.query.appear_id) {
      this.searchInfo.appear_id = Number(this.$route.query.appear_id);
    }
    if (this.$route.query.source_id) {
      this.searchInfo.source_id = Number(this.$route.query.source_id);
      sourceTypeSelectListApi().then((result: any) => {
        let target = result.data.list.find((s: any) => {
          return s.source_id === Number(this.$route.query.source_id);
        });
        if (target) {
          this.studentSourceList = [target];
        }
      });
    }
    this.getStageList({}, () => {
      this.getList({
        page: this.page,
        pageSize: this.pageSize,
      });
    });
  }
  handleSearchSource() {
    if (!this.searchInfo.appear_id) {
      return false;
    }
    sourceTypeSelectListApi({
      appear_id: this.searchInfo.appear_id,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.studentSourceList = res.data.list;
      }
    });
  }
  getStageList(val: any, cb?: Function) {
    if (val.current_stage) {
      delete val.current_stage;
    }
    this.stageNum = 0;
    // 等到两个接口请求回来再执行下面请求,以免学员阶段数据拿不到;
    studentStageApi().then((res: any) => {
      if (res.error_code === 0) {
        studentStageStatisticsApi(val).then((v: any) => {
          if (v.error_code === 0) {
            this.currentStageList = res.data.list;
            v.data.list.map((item: any) => {
              this.stageNum += item.total;
            });
            res.data.list.map((it: any) => {
              v.data.list.map((item: any) => {
                if (it.key === item.stage_id) {
                  it.total = item.total;
                }
              });
            });
            if (cb) {
              cb();
            }
          }
        });
      }
    });
  }
  getList(val: { page: number; pageSize: number }) {
    const data: statisticsStudentStageListInter = {
      page: val.page,
      page_size: val.pageSize,
    };
    const v = this.searchInfo;
    if (v.current_stage > -1) {
      data.current_stage = v.current_stage;
    }
    if (v.student_name) {
      data.key_word = v.student_name;
    }
    if (v.student_status) {
      data.student_status = v.student_status;
    }
    if (v.sex) {
      data.sex = v.sex;
    }
    if (v.age_stage) {
      data.age_stage = v.age_stage;
    }
    if (v.age_start) {
      data.age_start = v.age_start;
    }
    if (v.age_end) {
      data.age_end = v.age_end;
    }
    if (v.edu_teacher_id) {
      data.edu_teacher_id = v.edu_teacher_id;
    }
    if (v.follow_staff_id) {
      data.follow_staff_id = v.follow_staff_id;
    }
    if (v.appear_id) {
      data.appear_id = v.appear_id;
    }
    if (v.source_id) {
      data.source_id = v.source_id;
    }
    if ((v.intent_id || v.intent_id == 0) && v.intent_id !== "") {
      data.intent_id = Number(v.intent_id);
    }
    if (v.acquisition_time && v.acquisition_time.length > 0) {
      data.acquisition_start_time = v.acquisition_time[0];
      data.acquisition_end_time = v.acquisition_time[1];
    }
    if (v.transform_time && v.transform_time.length > 0) {
      data.transform_start_time = v.transform_time[0];
      data.transform_end_time = v.transform_time[1];
    }
    if (v.completion_time && v.completion_time.length > 0) {
      data.completion_start_time = v.completion_time[0];
      data.completion_end_time = v.completion_time[1];
    }
    if (v.create_time && v.create_time.length > 0) {
      data.create_start_time = v.create_time[0];
      data.create_end_time = v.create_time[1];
    }
    if (v.first_visited_time && v.first_visited_time.length > 0) {
      data.first_visited_start_time =
        new Date(v.first_visited_time[0] + " 00:00:01").getTime() / 1000;
      data.first_visited_end_time =
        new Date(v.first_visited_time[1] + " 23:59:59").getTime() / 1000;
    }
    if (v.first_experienced_time && v.first_experienced_time.length > 0) {
      data.first_experienced_start_time =
        new Date(v.first_experienced_time[0] + " 00:00:01").getTime() / 1000;
      data.first_experienced_end_time =
        new Date(v.first_experienced_time[1] + " 23:59:59").getTime() / 1000;
    }
    if (this.searchInfo.sort_type !== "") {
      data.sort_type = this.searchInfo.sort_type;
    }
    if (this.searchInfo.sort_field !== "") {
      data.sort_field = this.searchInfo.sort_field;
    }
    this.searchFormData = JSON.parse(JSON.stringify(data));
    statisticsStudentStageListApi(data).then((res: any) => {
      if (res.error_code === 0) {
        const today = new Date().getTime();
        res.data.list.map((item: any) => {
          this.currentStageList.map((it: any) => {
            if (item.current_stage === it.key) {
              item.studentStage = it.value;
            }
          });
          if (item.create_time) {
            item.create_time = dateFormat(
              "YYYY-mm-dd",
              item.create_time * 1000
            );
          } else {
            item.create_time = "-";
          }
          if (item.acquisition_time) {
            item.acquisition_time = dateFormat(
              "YYYY-mm-dd",
              item.acquisition_time * 1000
            );
          } else {
            item.acquisition_time = "-";
          }
          if (item.completion_time) {
            item.completion_time = dateFormat(
              "YYYY-mm-dd",
              item.completion_time * 1000
            );
          } else {
            item.completion_time = "-";
          }
          if (item.transform_time) {
            item.transform_time = dateFormat(
              "YYYY-mm-dd",
              item.transform_time * 1000
            );
          } else {
            item.transform_time = "-";
          }
          if (item.first_visited_time) {
            item.first_visited_time = dateFormat(
              "YYYY-mm-dd",
              item.first_visited_time * 1000
            );
          } else {
            item.first_visited_time = "-";
          }
          if (item.first_experienced_time) {
            item.first_experienced_time = dateFormat(
              "YYYY-mm-dd",
              item.first_experienced_time * 1000
            );
          } else {
            item.first_experienced_time = "-";
          }
          if (item.age === 0) {
            if (item.birthday !== 0) {
              const severalMonths = today - item.birthday * 1000;
              item.age = new Date(severalMonths).getMonth() + "个月";
            } else {
              item.age = "-";
            }
          } else {
            item.age = item.age + "岁";
          }
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    });
  }
  // 导出
  handleExport() {
    const data: statisticsStudentStageListExportInter = {};
    const v = this.searchInfo;
    if (v.current_stage > -1) {
      data.current_stage = v.current_stage;
    }
    if (v.student_name) {
      data.key_word = v.student_name;
    }
    if (v.student_status) {
      data.student_status = v.student_status;
    }
    if (v.sex) {
      data.sex = v.sex;
    }
    if (v.age_stage) {
      data.age_stage = v.age_stage;
    }
    if (v.age_start) {
      data.age_start = v.age_start;
    }
    if (v.age_end) {
      data.age_end = v.age_end;
    }
    if (v.edu_teacher_id) {
      data.edu_teacher_id = v.edu_teacher_id;
    }
    if (v.follow_staff_id) {
      data.follow_staff_id = v.follow_staff_id;
    }
    if (v.appear_id) {
      data.appear_id = v.appear_id;
    }
    if (v.source_id) {
      data.source_id = v.source_id;
    }
    if (v.intent_id || v.intent_id == 0) {
      data.intent_id = Number(v.intent_id);
    }
    if (v.acquisition_time && v.acquisition_time.length > 0) {
      data.acquisition_start_time = v.acquisition_time[0];
      data.acquisition_end_time = v.acquisition_time[1];
    }
    if (v.transform_time && v.transform_time.length > 0) {
      data.transform_start_time = v.transform_time[0];
      data.transform_end_time = v.transform_time[1];
    }
    if (v.completion_time && v.completion_time.length > 0) {
      data.completion_start_time = v.completion_time[0];
      data.completion_end_time = v.completion_time[1];
    }
    if (v.create_time && v.create_time.length > 0) {
      data.create_start_time = v.create_time[0];
      data.create_end_time = v.create_time[1];
    }
    // 时间戳
    if (v.first_visited_time && v.first_visited_time.length > 0) {
      data.first_visited_start_time =
        new Date(v.first_visited_time[0] + " 00:00:01").getTime() / 1000;
      data.first_visited_end_time =
        new Date(v.first_visited_time[1] + " 23:59:59").getTime() / 1000;
    }
    // 时间戳
    if (v.first_experienced_time && v.first_experienced_time.length > 0) {
      data.first_experienced_start_time =
        new Date(v.first_experienced_time[0] + " 00:00:01").getTime() / 1000;
      data.first_experienced_end_time =
        new Date(v.first_experienced_time[1] + " 23:59:59").getTime() / 1000;
    }
    if (this.searchInfo.sort_type !== "") {
      data.sort_type = this.searchInfo.sort_type;
    }
    if (this.searchInfo.sort_field !== "") {
      data.sort_field = this.searchInfo.sort_field;
    }
    statisticsStudentStageListExportApi(data).then((res: any) => {
      if (res.error_code === 0) {
        exportLoop(res.data.task_id);
      }
    });
  }
  handleGetEduTeacherList(v: any) {
    staffList({
      page: 1,
      page_size: 500,
      key_word: v,
      job_ids: [2],
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.eduTeacherList = res.data.list;
      }
    });
  }
  handleGetCourseAdviserList(v: any) {
    staffList({
      page: 1,
      page_size: 500,
      key_word: v,
      job_ids: [3],
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.courseAdviserList = res.data.list;
      }
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      pageSize: this.pageSize,
    });
    this.getStageList(this.searchFormData);
  }
  handleRadioSearch() {
    this.getList({
      page: 1,
      pageSize: this.pageSize,
    });
  }
  resetSearch() {
    this.searchInfo = {
      current_stage: -1,
      acquisition_time: [],
      transform_time: [],
      completion_time: [],
      create_time: [],
      first_visited_time: [],
      first_experienced_time: [],
      sort_type: "desc",
      sort_field: "",
    };
    this.getList({
      page: 1,
      pageSize: this.pageSize,
    });
    this.getStageList(this.searchFormData);
    this.mixinSavePageInfo("resourceManagement");
  }
  goStudentDetail(val: any) {
    this.$router.push({
      name: "studyDetails",
      query: {
        id: val,
      },
    });
    this.mixinSavePageInfo("resourceManagement");
  }
  // 排序
  clickStort(e: { order: string; prop: string }) {
    this.searchInfo.sort_field = e.prop;
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.getList({
      page: 1,
      pageSize: this.pageSize,
    });
  }
  handlePagerChange(e: number) {
    this.page = e;
    this.getList({
      page: e,
      pageSize: this.pageSize,
    });
    this.mixinSavePageInfo("resourceManagement");
  }
  handlePagerSizeChange(e: number) {
    this.page = 1;
    this.pageSize = e;
    this.getList({
      page: 1,
      pageSize: e,
    });
    this.mixinSavePageInfo("resourceManagement");
  }
}
